import React from "react";
import { useAuth } from "react-oidc-context";
import MainApp from "./components/MainApp"; // Asegúrate de que este import sea correcto según tu estructura
import LoadingScreen from "./components/LoadingScreen";
import "./styles/theme.css";
import "./styles/Init.css";


function App() {
  const auth = useAuth();

  if (auth.isLoading) {
    return <LoadingScreen text="Validando credenciales..." />;
  }

  if (auth.error) {
    return (
      <div className="error-container">
        <h3>Acceso Denegado</h3>
        <p>{auth.error.message}</p>
        <button onClick={() => auth.signinRedirect()}>Reintentar Login</button>
      </div>
    );
  }

  if (auth.isAuthenticated) {
    return <MainApp />;
  }

  return (
    <div className="app-container">
      <h1 className="welcome-title">Bienvenido a AI Coworker Clientes</h1>
      <p className="security-notice">Acceso monitoreado y auditado.</p>
      <button className="login-button" onClick={() => auth.signinRedirect()}>
        Iniciar Sesión Corporativa
      </button>
    </div>
  );
}

export default App;
